var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 bg-white rounded-lg h-100"},[(_vm.isTableDataLoaded && !_vm.hideTableContent)?_c('DataTable'):(!_vm.isTableDataLoaded && _vm.hideTableContent && !_vm.pageLoading)?_c('h1',{staticClass:"text-center grey--text lighten-5 mt-20"},[_vm._v(" No data available ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }